import React from "react";
import { Channel, useMessageContext, useTranslationContext } from "stream-chat-react";
import { useSpecialTransaction } from "../../../hooks/useSpecialTransaction";

export const CustomMessageActionList = () => {
  const { message, isMyMessage } = useMessageContext("CustomMessageActionList");

  const showZapMessage = message.cid && message.id && message.user?.id && !isMyMessage();
  const { zapMessage } = useSpecialTransaction();

  const handleZapMessage = () => {
    if(message.cid && message.id && message.user?.id) {
        zapMessage(message.cid, message.id, message.user.id);
    }
  }

  const handleCopyMessage = () => {
    navigator.clipboard.writeText(message.text || '')
        .catch((err) => {
            console.error('Failed to copy:', err);
        });
  }

  return (
    <>
        {showZapMessage && (
            <button
                className="str-chat__message-actions-list-item-button"
                onClick={handleZapMessage}
            >
                Zap Message
            </button>
        )}
        <button
            className="str-chat__message-actions-list-item-button"
            onClick={handleCopyMessage}
        >
            Copy Message
        </button>
    </>
  );
};